import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Perks of Collaborating with TekRevol for App Maintenance and Support</h2>
                        <p>Partnering with TekRevol for app maintenance and support services goes beyond mere technical assistance. It's a strategic partnership aimed at elevating your mobile application to new heights. With a dedicated team of experts, cutting-edge technologies, and a commitment to excellence, we offer an all-inclusive approach to app maintenance maintenance and support services.</p>
                    </Col>
                </Row>
                <Row className="h-100 perks-padd">
                <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                    <div className="perks-box">
                        <div className="perks-content">
                            <h4>Expertise-Driven <br/>Solutions</h4>
                            <p>Leverage the expertise of our dedicated team for tailored solutions, ensuring your app remains at the forefront of performance and innovation</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Proactive Issue <br/>Resolution</h4>
                            <p>Experience fluent app functionality with our proactive approach, identifying and resolving potential issues before they impact your users.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Tailored Maintenance<br/> Strategies</h4>
                            <p>Take advantage of our customized maintenance strategies, which align with your unique business objectives and app requirements.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Continuous Support and Optimization</h4>
                            <p>Beyond issue resolution, we offer continuous support, ensuring your app to progress through regular optimization and updates.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Perks